import axios from 'axios'
// import Api from '@/services/Api'
/* eslint-disable */
export default {
    subscribe(e) {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/Subscribe/Subscribe`, null, {
            params: {
                email: e
            }
        })
    }
}